var map = {
	"./az.svg": "4e9e",
	"./be.svg": "4bad",
	"./en.svg": "db2d",
	"./et.svg": "029e",
	"./hy.svg": "2719",
	"./ka.svg": "98c1",
	"./kk.svg": "0e65",
	"./ky.svg": "80f4",
	"./lt.svg": "c8ac",
	"./lv.svg": "0896",
	"./mn.svg": "1974",
	"./ru.svg": "e727",
	"./uz.svg": "e226"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "099c";